/**
 * useDebouncedValue — returns `value` after it has been stable for `delayMs`.
 *
 * Standard rising-edge debounce: each new value resets the timer; only the
 * final value of a burst is committed. Used by typeahead search inputs to
 * avoid hammering the API on every keystroke.
 */

import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
